import { SettingSource } from 'apis/notification-providers';
import { formatDateTime, Text } from 'design-system';

interface SettingSourceTextProps {
  source: SettingSource;
  envSettingName: string;
  updatedAt: string | null;
  updatedBy: { id: number; name: string | null } | null;
}

/** Where the choice in use comes from: this screen (who, when) or the server setting. */
export const SettingSourceText = ({ source, envSettingName, updatedAt, updatedBy }: SettingSourceTextProps) => {
  if (source === 'env') {
    return (
      <Text fontSize='sm' color='gray.500'>
        Using the server setting {envSettingName}.
      </Text>
    );
  }
  const who = updatedBy ? updatedBy.name ?? `user #${updatedBy.id}` : 'someone';
  return (
    <Text fontSize='sm' color='gray.500'>
      Chosen on this screen by {who}
      {updatedAt ? ` on ${formatDateTime(updatedAt)}` : ''}. It overrides the server setting {envSettingName}.
    </Text>
  );
};
